import type { ReactNode } from 'react';

export const symbol_airline_seat_flat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M390-400q-12.75 0-21.37-8.63Q360-417.25 360-430v-190q0-24.75 17.63-42.38Q395.25-680 420-680h308q63 0 107 44t44 107v99q0 12.75-8.62 21.37Q861.75-400 849-400H390Zm30-220v160-160Zm430 340H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-340 110-340h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5ZM115-435q-35-35-35-85t35-85q35-35 85-35t85 35q35 35 35 85t-35 85q-35 35-85 35t-85-35Zm127.5-42.5Q260-495 260-520t-17.5-42.5Q225-580 200-580t-42.5 17.5Q140-545 140-520t17.5 42.5Q175-460 200-460t42.5-17.5ZM420-460h399v-69q0-37.54-26.73-64.27Q765.54-620 728-620H420v160Zm-220-60Z"
		/>
	</svg>
);
